import classNames from 'classnames';
import React from 'react';

export interface loaderProps {
    customClass?: string
}

function Loader(props: loaderProps) {

    const {customClass} = props;

    return (
        <div className='card-loader-container'>
            <span className={classNames('card-loader',
                customClass? customClass: '')}></span>
        </div>
    );
}

export default Loader;
